import { Box, Grid, Typography } from "@mui/material";
import IconContainer from "./icons/IconContainer";
import LocationIcon from "./icons/LocationIcon";

export default function MapLocationsLegend({ categories }) {
  return (
    <Box>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ marginBottom: "1rem" }}
      >
        Legende
      </Typography>
      <Grid container spacing={1}>
        {categories.map((category) => {
          return (
            <Grid item xs={12} key={category.id}>
              <Grid container alignItems="center" spacing={1}>
                <Grid
                  item
                  xs="auto"
                  sx={{
                    "& div": {
                      width: "1.5rem !important",
                      height: "1.5rem !important",
                      "& svg": {
                        width: "0.75rem !important",
                        height: "0.75rem !important",
                      },
                    },
                  }}
                >
                  <IconContainer color={category?.color}>
                    <LocationIcon category={category} />
                  </IconContainer>
                </Grid>
                <Grid item xs>
                  <Typography sx={{ fontSize: "0.875rem !important" }}>
                    {category.name}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
